import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaTruck, FaMoneyBillWave, FaUndo, FaShieldAlt } from "react-icons/fa";
import CartDrawer from '../../components/CartDrawer/CartDrawer';
import { getProducts } from '../../services/api';
import ProductCard from '../../components/ProductCard/ProductCard';

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);

  useEffect(() => {
    getProducts({ featured: '1', limit: '3' }).then(data => setFeatured(data));
    getProducts({ bestseller: '1', limit: '6' }).then(data => setBestSellers(data));
    getProducts({ sort: 'newest', limit: '9' }).then(data => setNewArrivals(data));
  }, []);

  const testimonials = [
    {
      text: 'اشتريت مكنسة السجاد من برولاكس قبل 6 أشهر، وقوة الشفط ما زالت ممتازة. وفرت عليّ وقت وجهد كبير خصوصاً مع وجود أطفال في البيت.',
      author: 'محمد أبو سمرة',
      location: 'رام الله'
    },
    {
      text: 'الغلاية الكهربائية من برولاكس أصبحت جزءاً أساسياً من يومي. تسخن الماء بسرعة وجودتها واضحة من أول استخدام.',
      author: 'لينا خليل',
      location: 'نابلس'
    },
    {
      text: 'القلاية الهوائية رائعة جداً، البطاطا والدجاج يخرجون مقرمشين بدون زيت تقريباً. من أفضل المشتريات للمطبخ.',
      author: 'سمر العبد',
      location: 'الخليل'
    }
  ];

  return (
    <div className="bg-black min-h-screen" dir="rtl">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;900&display=swap');
        * { font-family: 'Tajawal', sans-serif; }
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
      <CartDrawer />

      {/* 1. HERO */}
      <section className="relative min-h-screen flex items-center bg-black overflow-hidden pt-20">
        <motion.div animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.4, 0.2] }} transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }} className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-red-600/20 rounded-full blur-[120px]" />
        <motion.div animate={{ scale: [1, 1.3, 1], opacity: [0.1, 0.3, 0.1] }} transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 1 }} className="absolute bottom-1/4 left-1/4 w-[500px] h-[500px] bg-red-900/20 rounded-full blur-[100px]" />
        <div className="relative max-w-7xl mx-auto px-6 w-full grid lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, ease: "easeOut" }} className="text-right z-10">
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="inline-flex items-center gap-2 border border-red-600/30 bg-red-600/10 text-red-500 px-4 py-2 rounded-full text-sm font-bold mb-6 backdrop-blur-sm">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />الجودة الألمانية الأصلية
            </motion.div>
            <h1 className="text-6xl md:text-8xl font-black text-white leading-[1.1] mb-6"><span className="block">قوّة</span><span className="text-red-600">في مطبخك</span></h1>
            <p className="text-neutral-400 text-lg md:text-xl max-w-lg mr-auto ml-0 leading-relaxed mb-10">أجهزة منزلية احترافية صُممت لتدوم طويلاً وتمنحك تجربة طهي استثنائية. هندسة دقيقة لأداء لا يُضاهى.</p>
            <div className="flex flex-wrap gap-4">
              <Link to="/shop" className="group relative bg-red-600 text-white px-10 py-4 font-bold text-lg rounded-xl overflow-hidden transition-all hover:shadow-[0_0_40px_-10px_rgba(220,38,38,0.5)]"><span className="relative z-10">تسوق الآن</span><div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" /></Link>
              <Link to="/shop?category=blenders" className="border border-neutral-700 text-white hover:bg-neutral-800 hover:border-neutral-600 px-10 py-4 font-bold text-lg rounded-xl transition-all flex items-center gap-2">الأكثر مبيعاً<svg className="w-5 h-5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg></Link>
            </div>
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }} className="mt-16 flex gap-12 border-t border-neutral-800 pt-8">
              {[{ num: '١٠٠٠+', label: 'عميل سعيد' }, { num: '٥', label: 'سنوات ضمان' }, { num: '١٠٠+', label: 'منتج حصري' }].map((stat, i) => (
                <div key={i}><div className="text-3xl md:text-4xl font-black text-white mb-1">{stat.num}</div><div className="text-sm text-neutral-500 font-medium">{stat.label}</div></div>
              ))}
            </motion.div>
          </motion.div>
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, ease: "easeOut" }} className="relative hidden lg:block">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl shadow-red-900/20 border border-neutral-800">
              <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800&q=80" alt="Premium Kitchen" className="w-full h-[600px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            </div>
            <motion.div animate={{ y: [0, -15, 0] }} transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }} className="absolute -bottom-6 -right-6 z-20 bg-neutral-900/80 backdrop-blur-xl border border-neutral-700 p-6 rounded-2xl shadow-2xl max-w-xs">
              <div className="flex items-center gap-4 mb-3"><div className="w-12 h-12 rounded-full bg-red-600/20 flex items-center justify-center text-red-500"><svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg></div><div><div className="text-white font-bold">ضمان 5 سنوات</div><div className="text-neutral-400 text-sm">على جميع الأجهزة</div></div></div>
              <div className="w-full bg-neutral-800 h-1.5 rounded-full overflow-hidden"><div className="bg-red-600 h-full w-3/4 rounded-full" /></div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* 2. FEATURES BAR */}
      <section className="relative z-20 -mt-8 px-6">
        <div className="max-w-6xl mx-auto bg-neutral-900/60 backdrop-blur-xl border border-neutral-800 rounded-2xl p-6 grid grid-cols-2 md:grid-cols-4 gap-6 shadow-2xl shadow-black/50">
          {[{ icon: <FaTruck />, title: 'توصيل مجاني', desc: 'للطلبات فوق ٥٠٠ شيقل' }, { icon: <FaMoneyBillWave />, title: 'الدفع عند الاستلام', desc: 'لا حاجة لبطاقة ائتمان' }, { icon: <FaUndo />, title: 'إرجاع مجاني', desc: 'خلال ١٤ يوم من الاستلام' }, { icon: <FaShieldAlt />, title: 'ضمان ٥ سنوات', desc: 'شامل جميع المنتجات' }].map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="flex items-center gap-4 p-2 text-white">
              <div className="text-2xl">{item.icon}</div><div><h3 className="font-semibold">{item.title}</h3><p className="text-sm text-neutral-400">{item.desc}</p></div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 3. FEATURED PRODUCT
      {featured.length > 0 && (
        <section className="py-24 px-6 bg-neutral-950">
          <div className="max-w-7xl mx-auto">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-16 text-center">
              <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">مختارة بعناية</span><h2 className="text-4xl md:text-5xl font-black text-white">المنتج المميز</h2>
            </motion.div>
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
                <div className="absolute inset-0 bg-red-600/10 blur-3xl rounded-full" />
                <img src={featured[0].image_url} alt={featured[0].name} className="relative z-10 w-full rounded-3xl shadow-2xl border border-neutral-800" />
              </motion.div>
              <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="text-right">
                <div className="inline-block bg-red-600/10 text-red-500 px-4 py-1 rounded-full text-sm font-bold mb-6">الأكثر طلباً</div>
                <h3 className="text-4xl md:text-5xl font-black text-white mb-6">{featured[0].name}</h3>
                <p className="text-neutral-400 text-lg leading-relaxed mb-8">{featured[0].description}</p>
                <div className="flex items-center gap-6 mb-10">
                  <span className="text-4xl font-black text-white">{featured[0].price} ₪</span>
                  {featured[0].old_price && <span className="text-neutral-500 line-through text-xl">{featured[0].old_price} ₪</span>}
                </div>
                <div className="flex flex-wrap gap-4">
                  <Link to={`/product/${featured[0].slug}`} className="bg-red-600 hover:bg-red-700 text-white px-10 py-4 font-bold text-lg rounded-xl transition-all shadow-lg shadow-red-600/20">عرض التفاصيل</Link>
                  <Link to="/shop" className="border border-neutral-700 text-white hover:bg-neutral-800 px-10 py-4 font-bold text-lg rounded-xl transition-all">تصفح المتجر</Link>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      )} */}
        {/* 3. FEATURED PRODUCT — ENHANCED */}
{featured.length > 0 && (
  <section className="py-24 px-6 bg-neutral-950 relative overflow-hidden">
    {/* Background glow */}
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-red-600/5 rounded-full blur-[150px]" />
    
    <div className="max-w-7xl mx-auto relative z-10">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        whileInView={{ opacity: 1, y: 0 }} 
        viewport={{ once: true }} 
        className="mb-16 text-center"
      >
        <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">مختارة بعناية</span>
        <h2 className="text-4xl md:text-5xl font-black text-white">المنتج المميز</h2>
      </motion.div>

      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Image Side */}
        <motion.div 
          initial={{ opacity: 0, x: -50 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          viewport={{ once: true }} 
          className="relative"
        >
          {/* Glow behind image */}
          <div className="absolute -inset-4 bg-red-600/10 blur-3xl rounded-full" />
          
          {/* Main Image */}
          <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl border border-neutral-800 group">
            <img 
              src={featured[0].image_url} 
              alt={featured[0].name} 
              className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105" 
            />
            
            {/* Discount badge (if exists) */}
            {featured[0].old_price && featured[0].old_price > featured[0].price && (
              <div className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-xl font-black text-lg shadow-lg">
                وفر {Math.round((1 - featured[0].price / featured[0].old_price) * 100)}%
              </div>
            )}

            {/* Stock badge */}
            <div className={`absolute top-4 left-4 px-4 py-2 rounded-xl text-sm font-bold shadow-lg backdrop-blur-sm ${
              featured[0].stock > 0 
                ? 'bg-green-900/80 text-green-400 border border-green-700' 
                : 'bg-red-900/80 text-red-400 border border-red-700'
            }`}>
              <span className={`inline-block w-2 h-2 rounded-full mr-2 ${featured[0].stock > 0 ? 'bg-green-400' : 'bg-red-400'}`}></span>
              {featured[0].stock > 0 ? 'متوفر' : 'نفذت الكمية'}
            </div>
          </div>

    {/* Thumbnail indicators (if multiple images) */}
{(() => {
  // Parse images — handle both string and array
  let images = [];
  if (featured[0].images) {
    if (typeof featured[0].images === 'string') {
      try { images = JSON.parse(featured[0].images); } catch (e) { images = []; }
    } else if (Array.isArray(featured[0].images)) {
      images = featured[0].images;
    }
  }

  if (images.length > 1) {
    return (
      <div className="flex justify-center gap-2 mt-4">
        {images.slice(0, 4).map((img, i) => (
          <div key={i} className="w-14 h-14 rounded-lg overflow-hidden border-2 border-neutral-800 hover:border-red-500 transition cursor-pointer">
            <img src={img} alt="" className="w-full h-full object-cover" />
          </div>
        ))}
      </div>
    );
  }
  return null;
})()}
        </motion.div>

        {/* Info Side */}
        <motion.div 
          initial={{ opacity: 0, x: 50 }} 
          whileInView={{ opacity: 1, x: 0 }} 
          viewport={{ once: true }} 
          className="text-right"
        >
          {/* Category + Brand */}
          <div className="flex items-center gap-3 mb-4">
            <span className="text-xs text-neutral-400 bg-neutral-900 px-3 py-1 rounded-full border border-neutral-800">
              {featured[0].category_ar || featured[0].category}
            </span>
            <span className="text-xs text-neutral-500">{featured[0].brand || 'برولاكس'}</span>
          </div>

          {/* Badge */}
          <div className="inline-block bg-red-600/10 text-red-500 px-4 py-1.5 rounded-full text-sm font-bold mb-6 border border-red-600/20">
            ✦ الأكثر طلباً
          </div>

          {/* Product Name */}
          <h3 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight">
            {featured[0].name}
          </h3>

          {/* Description */}
          <p className="text-neutral-400 text-lg leading-relaxed mb-8 line-clamp-4">
            {featured[0].description || 'منتج عالي الجودة من برولاكس، مصمم بأعلى معايير الجودة الألمانية.'}
          </p>

          {/* Specs Highlights */}
          {featured[0].specs && (
            <div className="grid grid-cols-2 gap-3 mb-8">
              {Object.entries(
                typeof featured[0].specs === 'string' 
                  ? JSON.parse(featured[0].specs) 
                  : featured[0].specs
              ).slice(0, 4).map(([key, val]) => (
                <div key={key} className="flex items-center gap-2 bg-neutral-900/50 border border-neutral-800 rounded-xl px-4 py-2">
                  <div className="w-1.5 h-1.5 bg-red-500 rounded-full shrink-0"></div>
                  <span className="text-neutral-400 text-sm">{val}</span>
                </div>
              ))}
            </div>
          )}

          {/* Price */}
          <div className="flex items-baseline gap-4 mb-10">
            <span className="text-5xl font-black text-white">{featured[0].price} ₪</span>
            {featured[0].old_price && (
              <>
                <span className="text-2xl text-neutral-500 line-through">{featured[0].old_price} ₪</span>
                <span className="text-sm text-red-400 font-bold">
                  وفر {featured[0].old_price - featured[0].price} ₪
                </span>
              </>
            )}
          </div>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4">
            <Link 
              to={`/product/${featured[0].slug}`} 
              className="bg-red-600 hover:bg-red-700 text-white px-10 py-4 font-bold text-lg rounded-xl transition-all shadow-lg shadow-red-600/20 hover:shadow-red-600/40"
            >
              عرض التفاصيل ←
            </Link>
            <Link 
              to="/shop" 
              className="border border-neutral-700 text-white hover:bg-neutral-800 hover:border-neutral-600 px-10 py-4 font-bold text-lg rounded-xl transition-all"
            >
              تصفح المتجر
            </Link>
          </div>

          {/* Free shipping note */}
          <p className="text-neutral-600 text-sm mt-6">
             توصيل مجاني للطلبات فوق ٥٠٠ شيقل
          </p>
        </motion.div>
      </div>
    </div>
  </section>
)}
      {/* 4. BEST SELLERS */}
      {bestSellers.length > 0 && (
        <section className="py-24 px-6 bg-black overflow-hidden">
          <div className="max-w-7xl mx-auto">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex justify-between items-end mb-12">
              <div><span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">الأعلى مبيعاً</span><h2 className="text-4xl md:text-5xl font-black text-white">المنتجات الرائجة</h2></div>
              <Link to="/shop?sort=bestseller" className="hidden md:flex text-neutral-400 hover:text-white font-bold items-center gap-2 transition-colors group">عرض الكل<svg className="w-5 h-5 rotate-180 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg></Link>
            </motion.div>
            <div className="flex gap-6 overflow-x-auto pb-8 snap-x snap-mandatory scrollbar-hide -mx-6 px-6">
              {bestSellers.map((p, i) => (
                <motion.div key={p.id} initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="snap-center shrink-0 w-[300px] md:w-[350px]">
                  <ProductCard product={p} />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 5. QUALITY PROMISE */}
      <section className="py-24 px-6 bg-neutral-950 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-red-900/10 via-transparent to-transparent" />
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
            <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">نضمن لكم</span><h2 className="text-4xl md:text-5xl font-black text-white">تجربة تسوق استثنائية</h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: (<svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>), title: 'توصيل سريع', desc: 'نوصل طلبك خلال 2-5 أيام عمل إلى باب منزلك.' },
              { icon: (<svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>), title: 'منتجات أصلية', desc: 'جميع منتجاتنا أصلية 100% مع ضمان 5 سنوات.' },
              { icon: (<svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" /></svg>), title: 'دعم فني 24/7', desc: 'فريق دعم عربي جاهز لمساعدتك في أي وقت.' },
            ].map((item, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }} className="text-center group">
                <div className="w-20 h-20 mx-auto mb-6 bg-neutral-900 border border-neutral-800 group-hover:border-red-600/50 rounded-2xl flex items-center justify-center text-red-500 transition-all duration-300">{item.icon}</div>
                <h3 className="text-white text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-neutral-400 leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. NEW ARRIVALS */}
      {newArrivals.length > 0 && (
        <section className="py-24 px-6 bg-black">
          <div className="max-w-7xl mx-auto">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
              <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">أحدث المنتجات</span><h2 className="text-4xl md:text-5xl font-black text-white">وصل حديثاً</h2>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {newArrivals.map((p, i) => (
                <motion.div key={p.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }} className={i === 1 ? 'md:mt-12' : ''}>
                  <ProductCard product={p} />
                </motion.div>
              ))}
            </div>
            <div className="text-center mt-16">
              <Link to="/shop?sort=newest" className="inline-flex items-center gap-2 border border-neutral-700 text-white hover:bg-neutral-800 px-8 py-3 font-bold rounded-xl transition-all">عرض جميع المنتجات الجديدة</Link>
            </div>
          </div>
        </section>
      )}

      {/* 7. HOW TO ORDER */}
      <section className="py-24 px-6 bg-neutral-950">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">سهل وسريع</span><h2 className="text-4xl font-black text-white">كيف تطلب؟</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[{ step: '01', title: 'تصفح المنتجات', desc: 'اختر ما يناسبك من مجموعتنا الواسعة.' }, { step: '02', title: 'أضف إلى السلة', desc: 'اجمع مشترياتك واضغط على إتمام الطلب.' }, { step: '03', title: 'استلم وادفع', desc: 'نوصلك طلبك وتدفع عند الاستلام.' }].map((item, i) => (
              <div key={i} className="text-center">
                <div className="text-6xl font-black text-red-600/20 mb-4">{item.step}</div>
                <h3 className="text-white font-bold text-xl mb-2">{item.title}</h3>
                <p className="text-neutral-400">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7.5 OUR LOCATIONS — MAP STYLE */}
<section className="py-24 px-6 bg-neutral-950">
  <div className="max-w-4xl mx-auto">
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="text-center mb-16"
    >
      <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">أين تجدنا</span>
      <h2 className="text-4xl md:text-5xl font-black text-white">فروع برولاكس</h2>
    </motion.div>

    {/* Map-like layout */}
    <div className="relative">
      {/* Vertical line (road) */}
      <div className="absolute right-8 top-0 bottom-0 w-0.5 bg-neutral-800 hidden md:block"></div>

      <div className="space-y-6">
        {[
          {
            city: 'رام الله',
            location: 'تاج مول',
            address: 'شارع المستشفى',
            landmark: 'قرب المستشفى الاستشاري',
            color: 'border-red-600/50 bg-red-600/10',
            dot: 'bg-red-500'
          },
          {
            city: 'الخليل',
            location: 'سوق السكر',
            address: 'الهيبرون سنتر',
            landmark: 'وسط البلد',
            color: 'border-neutral-700 bg-neutral-900',
            dot: 'bg-neutral-500'
          },
          {
            city: 'قلقيلية',
            location: 'سيدتي مول',
            address: 'شارع التربية والتعليم',
            landmark: 'قرب مبنى التربية',
            color: 'border-red-600/50 bg-red-600/10',
            dot: 'bg-red-500'
          },
          {
            city: 'نابلس',
            location: 'صوالحه مول',
            address: 'شارع المعاجين',
            landmark: 'منطقة تجارية',
            color: 'border-neutral-700 bg-neutral-900',
            dot: 'bg-neutral-500'
          },
          {
            city: 'طولكرم',
            location: 'صوالحه مول',
            address: 'شارع باريس',
            landmark: 'مركز المدينة',
            color: 'border-red-600/50 bg-red-600/10',
            dot: 'bg-red-500'
          },
        ].map((branch, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="relative"
          >
            {/* Dot on the road (desktop) */}
            <div className="hidden md:flex absolute right-[22px] top-10 items-center justify-center z-10">
              <div className={`w-5 h-5 ${branch.dot} rounded-full border-2 border-neutral-950 shadow-lg`}></div>
            </div>

            {/* Card */}
            <div className={`mr-0 md:mr-16 border ${branch.color} rounded-2xl p-6 hover:border-red-500/50 transition-all duration-300`}>
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl bg-neutral-800 flex items-center justify-center shrink-0">
                    <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>

                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-white font-bold text-lg">{branch.location}</h3>
                      <span className="text-xs text-red-400 bg-red-600/10 px-2 py-0.5 rounded-full">{branch.city}</span>
                    </div>
                    <p className="text-neutral-400 text-sm">{branch.address}</p>
                    <p className="text-neutral-500 text-xs mt-1">{branch.landmark}</p>
                  </div>
                </div>

                {/* Arrow indicator */}
                <div className="hidden md:block text-neutral-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Bottom note */}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-center text-neutral-500 text-sm mt-10"
      >
         توصيل مجاني لجميع مدن الضفة للطلبات فوق ٥٠٠ شيقل
      </motion.p>
    </div>
  </div>
</section>

      {/* 8. TESTIMONIALS */}
      <section className="py-24 px-6 bg-black">
        <div className="max-w-7xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
            <span className="text-red-500 text-sm font-bold tracking-widest uppercase mb-2 block">آراء العملاء</span><h2 className="text-4xl md:text-5xl font-black text-white">ماذا يقولون عنا</h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((t, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-neutral-900 border border-neutral-800 rounded-3xl p-8 relative hover:border-red-600/30 transition-colors">
                <div className="text-red-600/20 text-8xl font-serif absolute top-4 right-6 select-none">"</div>
                <p className="text-neutral-300 leading-relaxed relative z-10 mb-8 text-lg">{t.text}</p>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-neutral-800 flex items-center justify-center text-white font-bold text-lg">{t.author.charAt(0)}</div>
                  <div><strong className="block text-white font-bold">{t.author}</strong><span className="text-neutral-500 text-sm">{t.location}</span></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 9. FINAL CTA */}
      <section className="py-32 px-6 bg-black relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-red-900/30 via-black to-black" />
        <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="relative z-10 max-w-4xl mx-auto text-center">
          <h2 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">هل أنت مستعد لتجربة <span className="text-red-500">مختلفة؟</span></h2>
          <p className="text-neutral-400 text-xl mb-10 max-w-2xl mx-auto">أطلب الآن وادفع عند الاستلام. توصيل مجاني للطلبات فوق ٥٠٠ شيقل.</p>
          <Link to="/shop" className="inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-12 py-5 font-bold text-xl rounded-2xl transition-all shadow-[0_0_60px_-15px_rgba(220,38,38,0.5)] hover:shadow-[0_0_80px_-15px_rgba(220,38,38,0.7)]">تصفح المنتجات<svg className="w-6 h-6 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg></Link>
        </motion.div>
      </section>
    </div>
  );
}